var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("some error block the app")]),_c('h2',[_vm._v("error number "+_vm._s(_vm.$route.params.code))])])}
var staticRenderFns = []

export { render, staticRenderFns }